<template>
    <div id="mstdnpicker-content">
        <div id="loading">
            <img id="loading_img" src="loading.gif" />
            <span id="loading_msg">トゥート取得中</span>
        </div>
        <div id="status_list" class='status-list'></div>
    </div>
</template>

<script>
export default{
    name : 'mstdnpicker-content',
};
</script>

<style scoped>
</style>

